export default [
  {
    name: 'project_tabs',
    component_path: 'modules/templates/columns/project/ProjectTabs',
    settings: {
      query: 'tab'
    }
  }
]